// import React, { useMemo, useState } from "react";
// import "./CssFiles/day-scheduler.css";

// /** ---------- DEMO WRAPPER (static data) ---------- */
// export default function DemoDayScheduler() {
//   const [currentDate, setCurrentDate] = useState(new Date("2025-08-19"));

//   const appointments = useMemo(
//     () => [
//       {
//         id: "d1",
//         date: "2025-08-19",
//         startTime: "09:00",
//         endTime: "09:30",
//         Duration: "30",
//         patientRequestId: { firstName: "Alice", lastName: "Brown" },
//         doctorRequestId: { firstName: "Bob", lastName: "Taylor" },
//       },
//       {
//         id: "d2",
//         date: "2025-08-19",
//         startTime: "11:30",
//         endTime: "12:30",
//         Duration: "60",
//         patientRequestId: { firstName: "Robert", lastName: "Lee" },
//         doctorRequestId: { firstName: "Bob", lastName: "Taylor" },
//       },
//       {
//         id: "d3",
//         date: "2025-08-19",
//         startTime: "14:15",
//         endTime: "15:00",
//         Duration: "45",
//         patientRequestId: { firstName: "Mina", lastName: "Khan" },
//         doctorRequestId: { firstName: "Bob", lastName: "Taylor" },
//       },
//       {
//         id: "d4",
//         date: "2025-08-19",
//         startTime: "16:00",
//         endTime: "17:00",
//         Duration: "60",
//         patientRequestId: { firstName: "Sara", lastName: "Patel" },
//         doctorRequestId: { firstName: "Bob", lastName: "Taylor" },
//       },
//     ],
//     []
//   );

//   return (
//     <DayView
//       currentDate={currentDate}
//       setCurrentDate={setCurrentDate}
//       appointments={appointments}
//       timeInterval={60}
//       rowHeight={60}
//     />
//   );
// }

// /** ---------- CORE DAY VIEW (unique class names: ds-*) ---------- */
// export function DayView({
//   currentDate,
//   setCurrentDate,
//   appointments,
//   timeInterval = 60,
//   rowHeight = 60,
// }) {
//   const [activeAppointment, setActiveAppointment] = useState(null);
//   const timeSlots = useMemo(() => generateTimeSlots(timeInterval), [timeInterval]);

//   return (
//     <div className="ds-day">
//       {/* header */}
//       <div className="ds-day-header">
//         <button
//           className="ds-btn ds-btn--outline"
//           onClick={() => setCurrentDate(addDays(currentDate, -1))}
//         >
//           ◀
//         </button>
//         <div className="ds-day-title">
//           {currentDate.toLocaleDateString("en-US", {
//             weekday: "long",
//             month: "short",
//             day: "numeric",
//             year: "numeric",
//           })}
//         </div>
//         <button
//           className="ds-btn ds-btn--outline"
//           onClick={() => setCurrentDate(addDays(currentDate, 1))}
//         >
//           ▶
//         </button>
//       </div>

//       {/* scroll area */}
//       <div
//         className="ds-scroll"
//         style={{ "--row-h": `${rowHeight}px` }} /* keep CSS grid aligned */
//       >
//         {/* left time rail */}
//         <div className="ds-time-col">
//           {timeSlots.map((slot, i) => (
//             <div key={i} className="ds-time-cell" style={{ height: `${rowHeight}px` }}>
//               {slot.display}
//             </div>
//           ))}
//         </div>

//         {/* right content grid */}
//         <div className="ds-content">
//           <div className="ds-rows">
//             {timeSlots.map((slot, i) => {
//               const filtered =
//                 appointments?.filter((app) => {
//                   const appDate = toDateOnly(app.date);
//                   const viewDate = toDateOnlyISO(currentDate);

//                   const isSameDate =
//                     appDate.getFullYear() === viewDate.getFullYear() &&
//                     appDate.getMonth() === viewDate.getMonth() &&
//                     appDate.getDate() === viewDate.getDate();

//                   const [h, m = 0] = (app.startTime || "00:00").split(":").map(Number);
//                   const appStartMinutes = h * 60 + m;

//                   return (
//                     isSameDate &&
//                     appStartMinutes >= slot.value &&
//                     appStartMinutes < slot.value + timeInterval
//                   );
//                 }) || [];

//               return (
//                 <div key={i} className="ds-row" style={{ height: `${rowHeight}px` }}>
//                   {filtered.map((app) => {
//                     // precise minute offset + duration height
//                     const [, appMinute = 0] = (app.startTime || "00:00")
//                       .split(":")
//                       .map(Number);
//                     const durationMin = Number(app.Duration || 0);
//                     const topOffset = (appMinute % timeInterval) / timeInterval * rowHeight;
//                     const heightPx = Math.max(28, (durationMin / timeInterval) * rowHeight - 6);

//                     return (
//                       <div
//                         key={app.id}
//                         className="ds-apt"
//                         style={{ top: `${topOffset}px`, height: `${heightPx}px` }}
//                         onClick={() => setActiveAppointment(app)}
//                         title={`${app.startTime} – ${app.endTime}`}
//                       >
//                         <div className="ds-apt-label">
//                           <strong>Client:</strong> {app?.patientRequestId?.firstName}{" "}
//                           {app?.patientRequestId?.lastName}
//                           <br />
//                           <strong>Provider:</strong> {app?.doctorRequestId?.firstName}{" "}
//                           {app?.doctorRequestId?.lastName}
//                           <br />
//                           <button
//                             className="ds-clockin"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               console.log("Clock In:", app);
//                             }}
//                           >
//                             Clock In
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* modal */}
//       {activeAppointment && (
//         <div className="ds-modal-overlay" onClick={() => setActiveAppointment(null)}>
//           <div className="ds-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ds-tip-card">
//               <div className="ds-tip-header">
//                 <div className="ds-tip-time">
//                   {activeAppointment.startTime} – {activeAppointment.endTime}
//                 </div>
//                 <div className="ds-tip-status">Scheduled</div>
//               </div>

//               <div className="ds-tip-section">
//                 <strong>Client:</strong> {activeAppointment?.patientRequestId?.firstName}{" "}
//                 {activeAppointment?.patientRequestId?.lastName}
//               </div>
//               <div className="ds-tip-section">
//                 <strong>Provider:</strong> {activeAppointment?.doctorRequestId?.firstName}{" "}
//                 {activeAppointment?.doctorRequestId?.lastName}
//               </div>

//               <div className="ds-tip-footer">
//                 <button onClick={() => setActiveAppointment(null)}>Close</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* ---------------- helpers ---------------- */
// function generateTimeSlots(intervalMinutes) {
//   const slots = [];
//   const totalMinutes = 24 * 60; // 1440
//   for (let i = 0; i < totalMinutes; i += intervalMinutes) { // stop at 23:00 to avoid duplicate 12 AM
//     const hours = Math.floor(i / 60) % 24;
//     const minutes = i % 60;

//     let displayHour = hours;
//     let period = "AM";
//     if (hours === 0) displayHour = 12;
//     else if (hours === 12) period = "PM";
//     else if (hours > 12) { displayHour = hours - 12; period = "PM"; }

//     const timeString =
//       intervalMinutes >= 60
//         ? `${displayHour} ${period}`
//         : `${displayHour}:${String(minutes).padStart(2, "0")} ${period}`;

//     slots.push({ value: i, display: timeString, hour: hours, minute: minutes });
//   }
//   return slots;
// }

// function addDays(date, days) { const d = new Date(date); d.setDate(d.getDate() + days); return d; }
// function toDateOnly(yyyy_mm_dd) { const [y,m,d] = yyyy_mm_dd.split("-").map(Number); return new Date(y, m-1, d); }
// function toDateOnlyISO(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

import moment from 'moment';
import React, { useState } from 'react'

const DemoDayScheduler = ({ currentDate,appointments}) => {
   const [timeInterval, setTimeInterval] = useState(60);
  const [activeAppointment, setActiveAppointment] = useState(null);


    const generateTimeSlots = (intervalMinutes) => {
    const slots = [];
    const totalMinutes = 24 * 60;

    for (let i = 0; i < totalMinutes; i += intervalMinutes) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;

      let displayHour = hours % 12 || 12;
      let period = hours < 12 ? "AM" : "PM";
      const timeString = `${displayHour}:${minutes
        .toString()
        .padStart(2, "0")} ${period}`;

      slots.push({ value: i, display: timeString });
    }

    return slots;
  };

  const timeSlots = generateTimeSlots(timeInterval);
    const rowHeight = 60;

  return (
       <div className="day-view_CalendarView">
                <div className="day-view-header_CalendarView">
                  {currentDate?.toDateString()}
                </div>

                <div className="day-scrollable-container">
                  <div className="day-time-column">
                    {timeSlots?.map((slot, index) => (
                      <div
                        key={index}
                        className="day-view-time_CalendarView"
                        style={{ height: `${rowHeight}px` }}
                        // onClick={() => {
                        //   console.log("Time slot clicked:", slot);
                        //   setSelectedSlot({ date: currentDate, slot });
                        //   setShowAppointmentPanel(true);
                        // }}
                      >
                        {slot.display}
                      </div>
                    ))}
                  </div>

                  <div className="day-content-container">
                    <div className="day-view-rows_CalendarView">
                      {timeSlots?.map((slot, index) => {
                        const filteredAppointments = appointments?.filter(
                          (app) => {
                            const appDate = new Date(app.date);
                            const viewDate = new Date(currentDate);

                            const isSameDate =
                              appDate.getFullYear() ===
                                viewDate.getFullYear() &&
                              appDate.getMonth() === viewDate.getMonth() &&
                              appDate.getDate() === viewDate.getDate();

                            const [appHour, appMinute] = (
                              app.startTime || "00:00"
                            )
                              .split(":")
                              ?.map(Number);
                            const appStartMinutes =
                              appHour * 60 + (appMinute || 0);

                            return (
                              isSameDate &&
                              appStartMinutes >= slot.value &&
                              appStartMinutes < slot.value + timeInterval
                            );
                          }
                        );

                        return (
                          <div
                            key={index}
                            className="day-view-row_CalendarView"
                            style={{ height: `${rowHeight}px` }}
                           
                          >
                            {filteredAppointments?.map((app, i) => (
                              <div
                                key={i}
                                className="appointment-block"
                                onClick={() => setActiveAppointment(app)}
                              >
                                <div className="appointment-label">
                                  Client: {app?.patientRequestId?.firstName}{" "}
                                  {app?.patientRequestId?.lastName}
                                  <br />
                                  Provider: {
                                    app?.doctorRequestId?.firstName
                                  }{" "}
                                  {app?.doctorRequestId?.lastName}
                                  <br />
                                  <button className="ClockIn_Button">
                                    Clock In
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                   {activeAppointment && (
                        <div
                          className="modal-overlay_week"
                          onClick={() => setActiveAppointment(null)}
                        >
                          <div
                            className="modal-content_week"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="tooltip-card">
                              <div className="tooltip-header">
                                <div className="tooltip-time">
                                  {(() => {
                                    if (
                                      !activeAppointment.startTime ||
                                      !activeAppointment.Duration
                                    ) {
                                      return activeAppointment.startTime || "N/A";
                                    }
                
                                    const start = moment(activeAppointment.startTime, "HH:mm");
                                    const durationMinutes = parseInt(
                                      activeAppointment.Duration
                                    );
                                    const end = start.clone().add(durationMinutes, "minutes");
                
                                    return `${start.format("HH:mm")} - ${end.format("HH:mm")}`;
                                  })()}
                                </div>
                                <div
                                  className="tooltip-status"
                                  style={{
                                    backgroundColor:
                                      activeAppointment?.appointmentStatus?.color,
                                  }}
                                >
                                  {activeAppointment?.appointmentStatus?.name}
                                </div>
                              </div>
                
                              <div className="tooltip-patient" style={{ textAlign: "left" }}>
                                <strong>
                                  {activeAppointment.patientRequestId?.firstName}{" "}
                                  {activeAppointment.patientRequestId?.lastName}
                                </strong>
                                <div>DOB: {activeAppointment.dob || "N/A"}</div>
                              </div>
                
                              <hr />
                
                              <div className="tooltip-section" style={{ textAlign: "left" }}>
                                <h4>Visit Information</h4>
                                <div>
                                  <strong>Provider:</strong> Dr.{" "}
                                  {activeAppointment.doctorRequestId?.firstName}{" "}
                                  {activeAppointment.doctorRequestId?.lastName}
                                </div>
                                <div>
                                  <strong>Appointment Type:</strong>{" "}
                                  {activeAppointment.deliveryMode?.name || "N/A"}
                                </div>
                                <div>
                                  <strong>Location:</strong>{" "}
                                  {activeAppointment.serviceLocationId?.name || "N/A"}
                                </div>
                                <div>
                                  <strong>Visit Reason:</strong>{" "}
                                  {activeAppointment.visitReason?.visitReason || "N/A"}
                                </div>
                                <div>
                                  <strong>Service Code(s):</strong>{" "}
                                  {activeAppointment.visitReason?.cptCode || "N/A"}
                                </div>
                                <div className="patient-intake">
                                  <strong>Patient Intake:</strong>
                                  <span> Pending </span>
                                  <button style={{ color: "black" }}>Resend</button>
                                </div>
                                <div>
                                  <strong>Balance:</strong> $0.00
                                </div>
                              </div>
                
                              <div className="tooltip-section" style={{ textAlign: "left" }}>
                                <h4>Financial Information</h4>
                                <div>
                                  <strong>Plan:</strong> BCBS FL HMO
                                </div>
                                <div>
                                  <strong>Effective:</strong> Not Specified
                                </div>
                                <div>
                                  <strong>Copay:</strong> $0.00
                                </div>
                                <div>
                                  <strong>Eligibility:</strong> Eligible for visit on 3/07/2025
                                  <div className="tooltip-actions">
                                    <a href="#">View Report</a>
                                    <a href="#">Check Again</a>
                                  </div>
                                </div>
                              </div>
                
                              <div className="tooltip-footer">
                                <button style={{ color: "black" }}> Status</button>
                                <button style={{ color: "black" }}>Create Note</button>
                                <button style={{ color: "black" }}>Actions</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
              </div>
  )
}

export default DemoDayScheduler